<template>
  <Form ref="loginForm" :model="form" :rules="rules" @keydown.enter.native="handleSubmit" class="login-form-box">
    <FormItem prop="code">
      <Input v-model="form.code" placeholder="合作伙伴账号" class="input">
       <!--  <span slot="prepend">
          <Icon :size="16" type="ios-person"></Icon>
        </span> -->
      </Input>
    </FormItem>
    <FormItem prop="password" class="password">
      <Input type="password" v-model="form.password" placeholder="密码" class="input">
        <!-- <span slot="prepend">
          <Icon :size="14" type="md-lock"></Icon>
        </span> -->
      </Input>
      <span class="btn" @click="tips">忘记密码</span>
    </FormItem>
    <FormItem>
      <Button @click="handleSubmit" type="primary" long class="login-btn hoverShow" style="margin-top:25px;">登录</Button>
      <!--  :class="{not:!form.code || !form.password}" -->
    </FormItem>
  </Form>
</template>
<script>
export default {
  name: "LoginForm",
  props: {
    codeRules: {
      type: Array,
      default: () => {
        return [{ required: true, message: "账号不能为空", trigger: "blur" }];
      }
    },
    passwordRules: {
      type: Array,
      default: () => {
        return [{ required: true, message: "密码不能为空", trigger: "blur" }];
      }
    }
  },
  data() {
    return {
      form: {
        code: "",
        password: ""
      }
    };
  },
  computed: {
    rules() {
      return {
        code: this.codeRules,
        password: this.passwordRules
      };
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.$emit("on-success-valid", {
            code: this.form.code,
            password: this.form.password
          });
        }
      });
    },
    tips(){
      this.$Message.error('请联系服务商重置密码')
    }
  }
};
</script>

<style lang="less">
.password{
  position: relative;
}
.password .btn{
  position: absolute;
  right: 10px;
  line-height: 45px;
  cursor: pointer;
}
</style>


